import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import CheckboxView from "../../components/view-form-components/checkbox-view";
import {
  FileDownloadView,
  MultiFileDownloadView,
} from "../../components/view-form-components/file-view";
import {
  ImageView,
  ImageViewArray,
} from "../../components/view-form-components/image.view";
import { JsonView } from "../../components/view-form-components/json-view";
import RadioView from "../../components/view-form-components/radio-view";
import {
  TextView,
  TextViewArray,
} from "../../components/view-form-components/text-view";
import MainLayout from "../../layout";
import { url } from "../../config";
import { types, uiTypes } from "../../utils/types";
import DeleteModal from "../../components/modal/delete-modal";
import SwitchView from "../../components/view-form-components/switch-view";
import { formatUnderscoreToSpace } from "../../utils/text-format";
import errorToast from "../../components/toast/errorToast";
import CommentsComponent from "../../components/comments/comments";
import FileCommentComponent from "../../components/comments/file-comment";
import CertificatePDF from "../../components/form/pdf";

const ViewPage = ({ model }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const viewId = id;
  const { tableName, columns, read, edit, create, references } = model;
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [deleteModalShow, setdeleteModalShow] = useState(false);

  const columnHeadings = () => {
    var array = [];
    for (var i = 0; i < columns.length; i++) {
      var column = columns[i];
      if (column.ui?.read == null || column.ui.read == true) {
        array.push(column.name);
      }
    }

    if (references != null) {
      for (let index = 0; index < references.length; index++) {
        const reference = references[index];
        array.push(reference.tableName);
      }
    }
    return array;
  };

  const headings = columnHeadings();

  const deleteFnc = (id) => {
    axios
      .post(`${url}/model/${tableName}/delete`, {
        id: id,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
        navigate(`/${tableName}/list`);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (viewId) {
      axios
        .post(`${url}/model/${tableName}/read`, { id: viewId ?? "" })
        .then((response) => {
          let resData = { ...response.data.data };

          if (references != null) {
            for (let index = 0; index < references.length; index++) {
              const reference = references[index];
              if (Array.isArray(resData[reference.tableName])) {
                var arrayValues = [];
                for (let j = 0; j < resData[reference.tableName].length; j++) {
                  const element = resData[reference.tableName][j];
                  arrayValues.push(element[reference.displayKey]);
                }
                resData[reference.tableName] = arrayValues.toString();
              } else if (
                resData[reference.tableName] &&
                typeof resData[reference.tableName] === "object"
              ) {
                if (
                  resData[reference.tableName][reference.displayKey] != null
                ) {
                  resData[reference.tableName] =
                    response.data.data[reference.tableName][
                      reference.displayKey
                    ];
                } else {
                  resData[reference.tableName] = "";
                }
              } else {
                resData[reference.tableName] = "";
              }
            }
          }

          setData(resData);
          setLoading(false);
        })
        .catch((error) => {
          errorToast(error?.response?.data?.message);
          console.error("API Error:", error);
          setLoading(false);
        });
    }
  }, [tableName, viewId]);

  if (loading) return <div>Loading...</div>;

  return (
    <MainLayout>
      <DeleteModal
        isOpen={deleteModalShow}
        onClose={() => {
          setdeleteModalShow(false);
        }}
        btnFnc={() => deleteFnc(id)}
      />
      <section className="h-full overflow-auto px-3">
        <div className="flex justify-between items-center mb-5 sticky top-0 bg-background pb-2 z-10">
          <h2 className="text-xl font-semibold capitalize">
            {formatUnderscoreToSpace(tableName)} - view
          </h2>
          <div className="flex gap-3 items-center">
            <CertificatePDF data={data} />
            <button
              onClick={() => navigate(`/${tableName}/edit/${id}`)}
              className="px-4 py-1 bg-primary border-[2px] border-primary text-white rounded"
            >
              Edit
            </button>
            <button
              onClick={() => {
                setdeleteModalShow(true);
              }}
              className="px-4 py-1 bg-errorColor border-[2px] border-errorColor text-white rounded"
            >
              Delete
            </button>
          </div>
        </div>

        {data ? (
          <section className="w-full max-w-[40rem]">
            {headings.map((heading, index) => {
              const column = columns.find((value) => value.name === heading);
              const value = data[heading];

              if (column?.ui?.type === uiTypes?.CHECKBOX) {
                return (
                  <CheckboxView key={index} label={heading} value={value} />
                );
              }
              if (column?.ui?.type === uiTypes?.SWITCH) {
                return <SwitchView key={index} label={heading} value={value} />;
              }
              if (column?.ui?.type === uiTypes?.RADIO) {
                return <RadioView key={index} label={heading} value={value} />;
              }
              if (column?.ui?.type === uiTypes.IMAGE) {
                return <ImageView key={index} label={heading} value={value} />;
              }
              if (
                column?.ui?.read &&
                column?.isArray &&
                column?.ui?.type === uiTypes.MULTI_IMAGE
              ) {
                return (
                  <ImageViewArray key={index} label={heading} value={value} />
                );
              }
              if (column?.ui?.type === uiTypes?.FILE) {
                return <FileDownloadView key={index} url={value} />;
              }
              if (column?.isArray && column?.ui?.type === uiTypes?.MULTI_FILE) {
                return <MultiFileDownloadView key={index} urls={value} />;
              }
              if (column?.ui?.type === uiTypes?.JSON) {
                return <JsonView key={index} label={heading} value={value} />;
              }
              if (column?.isArray && column?.type === types?.STRING) {
                return (
                  <TextViewArray key={index} label={heading} value={value} />
                );
              }
              return <TextView key={index} label={heading} value={value} />;
            })}
          </section>
        ) : (
          <div>Loading data...</div>
        )}
        <CommentsComponent tableName={tableName} viewId={viewId} />
        <FileCommentComponent tableName={tableName} viewId={viewId} />
      </section>
    </MainLayout>
  );
};

export default ViewPage;
